import React from 'react';
import { Line } from '../atoms/line';
import { Label } from '../atoms/label';

import useMedia from 'use-media';

export const PlanListConfirm = (props) => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div style={isWideTablet ? styles.confirmbox2 : styles.confirmbox}>
            <div style={isWideTablet ? styles.inputText2 : styles.inputText}>
                <div style={isWideTablet ? styles.inputName2 : styles.inputName}><Label label={props.label1} style={isWideTablet ? styles.titleSP : styles.title} /></div>
                <div style={isWideTablet ? styles.inputTextName2 : styles.inputTextName}>
                    <Label label={props.label2} style={isWideTablet ? styles.label2 : styles.label} />
                </div>
            </div>
            <Line style={styles.line}></Line>
        </div>
    );
}
const styles = {
    confirmbox: {
        width: "70%",
        margin: "0px auto",
    },
    confirmbox2: {
        width: "90%",
        margin: "0px auto",
    },
    title: {
        fontSize: "1rem",
        fontWeight: "bold",
        marginBottom: "15px",
    },
    titleSP: {
        fontSize: "16px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    label: {
        textAlign: "left",
        width: "100%",
        fontWeight: "bold",
        color: "black",
    },
    label2: {
        textAlign: "left",
        width: "100%",
        fontWeight: "bold",
        color: "rgb(111, 111, 111)",
        letterSpacing: 2
    },
    inputText: {
        display: "flex",
    },
    inputText2: {
        display: "block",
    },
    inputName: {
        width: "20%",
    },
    inputName2: {
        width: "100%",
    },
    inputTextName: {
        width: "70%",
    },
    inputTextName2: {
        width: "100%",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "10px auto 25px",
    },
}